import type { Anchor } from "@/types/live";
import { formatFollowers } from "@/utils/format";

interface AnchorCardProps {
  anchor: Anchor;
}

export default function AnchorCard({ anchor }: AnchorCardProps) {
  const tag = anchor.level === "vip" ? "VIP" : "新锐";
  return (
    <div className="flex flex-col items-center rounded-lg border border-background-200 bg-background-50 p-5 text-center">
      <span className="relative h-20 w-20 overflow-hidden rounded-full bg-secondary-200 outline outline-2 outline-primary-200">
        <img
          src={anchor.avatar}
          alt={`${anchor.name} 主播头像`}
          className="h-full w-full object-cover object-top"
        />
        {anchor.level === "vip" && (
          <span className="absolute -right-1 -top-1 flex h-6 w-6 items-center justify-center rounded-full bg-primary-500 text-xs text-background-50">
            <i className="ri-vip-crown-2-line text-sm" />
          </span>
        )}
      </span>
      <span className="mt-3 text-sm font-bold text-foreground-950">{anchor.name}</span>
      <span
        className={`mt-1 rounded-full px-2 py-0.5 text-xs font-medium ${
          anchor.level === "vip"
            ? "bg-primary-100 text-primary-700"
            : "bg-accent-100 text-accent-700"
        }`}
      >
        {tag}
      </span>
      <p className="mt-2 line-clamp-2 min-h-[36px] text-xs leading-relaxed text-foreground-500">
        {anchor.bio}
      </p>
      <span className="mt-3 flex items-center gap-1 text-xs text-foreground-600">
        <i className="ri-user-heart-line text-sm text-primary-500" />
        {formatFollowers(anchor.followers)} 粉丝
      </span>
    </div>
  );
}